import React from 'react'

export default function FaceFeature({ scaleX, fill, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <path
        d="M23.3677 1.42244C17.7477 0.112441 5.71774 0.112441 0.0877389 1.42244C-0.322261 6.88244 0.837739 23.6124 0.837739 23.6124C3.59774 26.1624 8.47774 26.6724 11.7277 26.6724C14.9777 26.6724 19.8577 26.1624 22.6177 23.6124C22.6177 23.6024 23.7777 6.88244 23.3677 1.42244ZM20.8777 17.8924L14.0877 20.5424L11.7777 16.1524L9.37774 20.5424L2.58774 17.8924L1.75774 2.82244H21.7177L20.8777 17.8924Z"
        fill={fill}
      />
    </g>
  )
}
